import { render, staticRenderFns } from "./uklon_market_labels.vue?vue&type=template&id=6244d916&scoped=true&"
import script from "./uklon_market_labels.vue?vue&type=script&lang=js&"
export * from "./uklon_market_labels.vue?vue&type=script&lang=js&"
import style0 from "./uklon_market_labels.vue?vue&type=style&index=0&id=6244d916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244d916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6244d916')) {
      api.createRecord('6244d916', component.options)
    } else {
      api.reload('6244d916', component.options)
    }
    module.hot.accept("./uklon_market_labels.vue?vue&type=template&id=6244d916&scoped=true&", function () {
      api.rerender('6244d916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/uklon/location/tabs/uklon_market_labels.vue"
export default component.exports